import React, { useState } from 'react';
import { hooks } from "@vote4dance/judging-sdk";
import { Form, Input, Modal } from 'antd';
var useSession = hooks.sessions.useSession;
import { _T } from '../../../../../base-react/src/Localization';
export const EmailParticipantsModal = (props) => {
    var _a;
    const { open, onClose, onEmail } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const sessionState = useSession();
    const onFinish = async (fieldsValue) => {
        setIsLoading(true);
        await onEmail(fieldsValue);
        setIsLoading(false);
        form.resetFields();
        onClose();
    };
    return (React.createElement(Modal, { title: _T('registration.contact.title'), open: open, onCancel: onClose, onOk: () => form.submit(), okButtonProps: { loading: isLoading } },
        React.createElement(Form, { name: "email_participant_settings", form: form, layout: "vertical", disabled: isLoading, onFinish: onFinish, initialValues: {
                from: (_a = sessionState === null || sessionState === void 0 ? void 0 : sessionState.userInfo) === null || _a === void 0 ? void 0 : _a.user_email
            } },
            React.createElement(Form.Item, { label: _T('registration.contact.subject'), name: "subject", rules: [{ required: true, message: _T('common.required') }] },
                React.createElement(Input, { type: 'subject' })),
            React.createElement(Form.Item, { label: _T('registration.contact.message'), name: "message", rules: [{ required: true, message: _T('common.required') }] },
                React.createElement(Input.TextArea, { rows: 5 })))));
};
